import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/storefront/app/components/legacy-slice-handler/legacy-slice-handler.tsx");
